import { getAuth, onAuthStateChanged } from "firebase/auth";
const { API_ROOT_URL } = require("../../../configs/activebuildconfig.json")

/**
 * CONTROLLER - puzzle
 * FUNCTION - editPuzzle
 * VERIFY - verified user
 * @param {*} puzzleId The data for the new puzzle
 * @param {*} callback callback function
 * @returns The puzzle data 
 */

export const editPuzzle = async (puzzleData, callback) => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken(false);
        const response = await fetch(`${API_ROOT_URL}/create/edit_puzzle`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                token,
                puzzleData
            }),
        })
        const result = await response.json();
        callback(result)
    })
}